import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const LibraryDashboard = lazy(() => import('../pages/library/LibraryDashboard'));
const BookList = lazy(() => import('../pages/library/BookList'));
const IssueBook = lazy(() => import('../pages/library/IssueBook'));
const ReturnBook = lazy(() => import('../pages/library/ReturnBook'));
const CirculationPage = lazy(() => import('../pages/library/CirculationPage'));
const LibraryStudentProfile = lazy(() => import('../pages/library/LibraryStudentProfile'));

const LibraryRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LibraryDashboard />} />
      <Route path="books" element={<BookList />} />
      <Route path="issue" element={<IssueBook />} />
      <Route path="return" element={<ReturnBook />} />
      <Route path="circulation" element={<CirculationPage />} />
      <Route path="student/:admissionNo" element={<LibraryStudentProfile />} />
    </Routes>
  );
};

export default LibraryRoutes;